import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import TikTokPlayer from '../Player';

const TikTokPreview = ({ sourceUrl, setTitleFromTikTok, previewReady, ...props }) => {
    const [previewImageUrl, setPreviewImageUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showPlayer, setShowPlayer] = useState(false);
    const [displayPreview, setDisplayPreview] = useState(true);
    const [previewImageLoaded, setPreviewImageLoaded] = useState(false);

    useEffect(() => {
        setPreviewImageLoaded(false);

        const fetchOembedData = async () => {
            try {
                const response = await fetch(`/api/oembed?url=${encodeURIComponent(sourceUrl)}&provider=tiktok`);
                
                if (!response.ok) {
                    throw new Error('Failed to fetch oEmbed data');
                }
                
                const data = await response.json();
                setPreviewImageUrl(data.thumbnail_url);
                setTitleFromTikTok && setTitleFromTikTok(data.title);
                previewReady && previewReady();
            } catch (error) {
                console.error('Error fetching TikTok oEmbed data:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchOembedData();
    }, [sourceUrl]);

    const play = () => {
        setShowPlayer(true);
        setDisplayPreview(false);
    }

    return (
        <div
            className={`flex flex-col items-center justify-center h-full w-full`}
            data-tiktok-preview-loaded={previewImageLoaded}
        >
            {previewImageUrl && (
                <div id="tiktok-preview-image-wrapper" className={`preview-image-wrapper overflow-hidden w-full relative flex items-center justify-center ${displayPreview ? 'block' : 'hidden'}`}>
                    <div className="bg-cover bg-center bg-no-repeat blur-sm absolute inset-0 max-h-full" style={{ backgroundImage: `url(${previewImageUrl})` }}>
                    </div>
                    <img
                        src={previewImageUrl}
                        alt="TikTok video preview"
                        className="aspect-[9/16] max-h-[200px] w-auto z-1"
                        onLoad={() => setPreviewImageLoaded(true)}
                    />
                    <div className="play-button absolute flex items-center justify-center z-3 p-2 rounded-full bg-black/50 cursor-pointer" onClick={play}>
                        <i data-feather="play" className="w-8 h-8 left-[2px] relative"></i>
                    </div>
                </div>
            )}
            {loading && (
                <div className="w-full h-full flex items-center justify-center">
                    <i data-feather="loader" className="w-4 h-4 animate-spin"></i>
                </div>
            )}
            {showPlayer &&
                <TikTokPlayer
                    {...props}
                    autoplay={true}
                />
            }
        </div>
    )
}

TikTokPreview.propTypes = {
    sourceUrl: PropTypes.string.isRequired,
    setTitleFromTikTok: PropTypes.func,
    previewReady: PropTypes.func,
}

export default TikTokPreview